import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_RECURRING_PAYABLES_REQUEST,
  GET_RECURRING_PAYABLES_SUCCESS,
  GET_RECURRING_PAYABLES_FAILURE,
  POST_RECURRING_PAYABLES_REQUEST,
  POST_RECURRING_PAYABLES_SUCCESS,
  POST_RECURRING_PAYABLES_FAILURE,
  UPDATE_RECURRING_PAYABLES_REQUEST,
  UPDATE_RECURRING_PAYABLES_SUCCESS,
  UPDATE_RECURRING_PAYABLES_FAILURE,
  DELETE_RECURRING_PAYABLES_REQUEST,
  DELETE_RECURRING_PAYABLES_SUCCESS,
  DELETE_RECURRING_PAYABLES_FAILURE,
  GET_RECURRING_PAYABLE_REQUEST,
  GET_RECURRING_PAYABLE_SUCCESS,
  GET_RECURRING_PAYABLE_FAILURE,
  POST_RP_LINEITEM_REQUEST,
  POST_RP_LINEITEM_SUCCESS,
  POST_RP_LINEITEM_FAILURE,
  PUT_RP_LINEITEM_REQUEST,
  PUT_RP_LINEITEM_SUCCESS,
  PUT_RP_LINEITEM_FAILURE,
  DELETE_RP_LINEITEM_REQUEST,
  DELETE_RP_LINEITEM_SUCCESS,
  DELETE_RP_LINEITEM_FAILURE,
  POST_RP_ATTACHMENT_REQUEST,
  POST_RP_ATTACHMENT_SUCCESS,
  POST_RP_ATTACHMENT_FAILURE,
  UPDATE_RP_ATTACHMENT_REQUEST,
  UPDATE_RP_ATTACHMENT_SUCCESS,
  UPDATE_RP_ATTACHMENT_FAILURE,
  DELETE_RP_ATTACHMENT_REQUEST,
  DELETE_RP_ATTACHMENT_SUCCESS,
  DELETE_RP_ATTACHMENT_FAILURE,
  POST_RP_LINE_ATTACHMENT_REQUEST,
  POST_RP_LINE_ATTACHMENT_SUCCESS,
  POST_RP_LINE_ATTACHMENT_FAILURE,
  DELETE_RP_LINE_ATTACHMENT_REQUEST,
  DELETE_RP_LINE_ATTACHMENT_SUCCESS,
  DELETE_RP_LINE_ATTACHMENT_FAILURE,
  GENERATE_RP_PAYMENT_SCHEDULE_FAILURE,
  GENERATE_RP_PAYMENT_SCHEDULE_SUCCESS,
  GENERATE_RP_PAYMENT_SCHEDULE_REQUEST
} from './recurringPayables.types';

export const getAllRecurringPayableSummaries = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_RECURRING_PAYABLES_REQUEST, GET_RECURRING_PAYABLES_SUCCESS, GET_RECURRING_PAYABLES_FAILURE],
    authenticated: true,
    endpoint: 'api/recurringPayables/summaries',
    method: 'GET'
  }
});

export const postRecurringPayable = values => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_RECURRING_PAYABLES_REQUEST, POST_RECURRING_PAYABLES_SUCCESS, POST_RECURRING_PAYABLES_FAILURE],
    authenticated: true,
    endpoint: 'api/recurringPayables',
    method: 'POST',
    payload: values
  }
});

export const updateRecurringPayable = (id, values) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_RECURRING_PAYABLES_REQUEST, UPDATE_RECURRING_PAYABLES_SUCCESS, UPDATE_RECURRING_PAYABLES_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${id}`,
    method: 'PUT',
    payload: values
  }
});

export const deleteRecurringPayable = id => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_RECURRING_PAYABLES_REQUEST, DELETE_RECURRING_PAYABLES_SUCCESS, DELETE_RECURRING_PAYABLES_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${id}`,
    method: 'DELETE'
  }
});

export const getRecurringPayableById = id => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_RECURRING_PAYABLE_REQUEST, GET_RECURRING_PAYABLE_SUCCESS, GET_RECURRING_PAYABLE_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${id}`,
    method: 'GET'
  }
});

export const createRecurringPayableLineItem = (recurringPayableId, payload) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_RP_LINEITEM_REQUEST, POST_RP_LINEITEM_SUCCESS, POST_RP_LINEITEM_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/lineItems`,
    method: 'POST',
    payload
  }
});

export const updateRecurringPayableLineItem = (recurringPayableId, lineItemId, payload) => ({
  [CALL_INTAKE_V2_API]: {
    types: [PUT_RP_LINEITEM_REQUEST, PUT_RP_LINEITEM_SUCCESS, PUT_RP_LINEITEM_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/lineItems/${lineItemId}`,
    method: 'PUT',
    payload
  }
});

export const deleteRecurringPayableLineItem = (recurringPayableId, lineItemId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_RP_LINEITEM_REQUEST, DELETE_RP_LINEITEM_SUCCESS, DELETE_RP_LINEITEM_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/lineItems/${lineItemId}`,
    method: 'DELETE'
  }
});

export const postRecurringPayableAttachment = (attachment, recurringPayableId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_RP_ATTACHMENT_REQUEST, POST_RP_ATTACHMENT_SUCCESS, POST_RP_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/attachments`,
    method: 'POST',
    payload: attachment
  }
});

export const updateRecurringPayableAttachment = (attachment, recurringPayableId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_RP_ATTACHMENT_REQUEST, UPDATE_RP_ATTACHMENT_SUCCESS, UPDATE_RP_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/attachments`,
    method: 'PUT',
    payload: attachment
  }
});

export const deleteRecurringPayableAttachment = (recurringPayableId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_RP_ATTACHMENT_REQUEST, DELETE_RP_ATTACHMENT_SUCCESS, DELETE_RP_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/attachments/${attachmentId}`,
    method: 'DELETE'
  }
});

export const addRecurringPayableLineAttachment = (recurringPayableId, lineItemId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_RP_LINE_ATTACHMENT_REQUEST, POST_RP_LINE_ATTACHMENT_SUCCESS, POST_RP_LINE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/lineItems/${lineItemId}/attachments/${attachmentId}`,
    method: 'POST'
  }
});

export const removeRecurringPayableLineAttachment = (recurringPayableId, lineItemId, attachmentId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_RP_LINE_ATTACHMENT_REQUEST, DELETE_RP_LINE_ATTACHMENT_SUCCESS, DELETE_RP_LINE_ATTACHMENT_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/lineItems/${lineItemId}/attachments/${attachmentId}`,
    method: 'DELETE'
  }
});

export const createPaymentSchedule = (recurringPayableId, request) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GENERATE_RP_PAYMENT_SCHEDULE_REQUEST, GENERATE_RP_PAYMENT_SCHEDULE_SUCCESS, GENERATE_RP_PAYMENT_SCHEDULE_FAILURE],
    authenticated: true,
    endpoint: `api/recurringPayables/${recurringPayableId}/schedule`,
    method: 'POST',
    payload: request
  }
});
